export type OrganizationStateDTO =
  (typeof OrganizationStateDTO)[keyof typeof OrganizationStateDTO];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationStateDTO = {
  inactive: 'inactive',
  submitted: 'submitted',
  approved: 'approved',
  rejected: 'rejected',
} as const;
